/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 11:01:53
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-27 15:36:35
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/common.ts
 */

import { generateLinkImg } from 'src/constrains/DraggableModules/tools';
export enum EnumCollapseId {
  mockupImage = 'saleChannelLinkProductCustomizationMockupImage',
  service = 'saleChannelLinkProductCustomizationService',
  customisationButton = 'saleChannelLinkProductCustomisationButton',
}
export const generateDefaultMockupImage = () => {
  return {
    enabled: false,
    caption: '',
    autoPlay: false,
    intervalTime: 1,
    linkModules: [generateLinkImg(1)],
  };
};
export const generateDefaultService = () => {
  return { selectedServiceUuid: null, termsAndConditionsUuid: null };
};
export const generateImage = () => {
  return generateLinkImg(1);
};

export const generateDefaultCustomisationButton = () => {
  return {
    text: '专属定制服务',
    outlineColour: '#000000',
    textColour: '#000000',
  };
};
